import {
  takeLatest, put, select,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import getDeclension from '@/helpers/getDeclension'
import {
  GET_LIVE_TIME_REPORT_TABLE,
  LIVE_TIME_REPORT_TABLE,

  SET_BAR_GRAPH_YEAR_OPTIONS,
  SET_BAR_GRAPH_PERSENT_OPTIONS,
  SET_GRAPH_TYPE,
} from '@/store/actions/lifeTimeReport'
import { GET_LIVE_TIME_REPORT_TABLE_URL } from '@/constants/apiRoutes'
import {
  successLiveTimeReportTable,
  errorLiveTimeReportTable,
} from '@/store/actions/lifeTimeReport/getTable'
import { getSelectedNode } from '@/store/selectors/appSettings'
import {
  getGraphType,
  getTableParameters,
  getSelectedGraphPercentOptions,
  getSelectedGraphYearOptions,
  getLiveTimeObjectTypes,
} from '@/store/selectors/lifeTimeReport'
import { GRAPH_PERCENT } from '@/components/charts/Graph/config'
import { setGlobalLoading } from '@/store/actions/appSettings'

const getFormattedCurrentDateExploitation = (value = '') => {
  const [years, months, days] = (value || '').split('-')

  const yearsPhrase = years > 0 ? `${years} ${getDeclension(years, ['год', 'года', 'лет'])} ` : ''
  const monthsPhrase = months > 0 ? `${months} мес. ` : ''
  const daysPhrase = days > 0 ? `${days} дн.` : ''

  return `${yearsPhrase}${monthsPhrase}${daysPhrase}`
}

function* getLiveTimeReportTableSaga() {
  try {
    yield put(setGlobalLoading(true))
    const node = yield select(getSelectedNode)

    const type = yield select(getGraphType)
    const tableParameters = yield select(getTableParameters)

    const selectedGraphPercentOptions = yield select(getSelectedGraphPercentOptions)
    const selectedGraphYearOptions = yield select(getSelectedGraphYearOptions)

    const objectTypes = yield select(getLiveTimeObjectTypes)

    const response = yield request({
      url: GET_LIVE_TIME_REPORT_TABLE_URL({
        options: type === GRAPH_PERCENT
            ? selectedGraphPercentOptions
            : selectedGraphYearOptions,
        pageNumber: tableParameters.page - 1,
        pageSize: tableParameters.perPage,
        parentId: node.id,
        search: tableParameters.requestQuery || '',
        sort: [`${tableParameters.sort.field}: ${tableParameters.sort.direction}`],
        type: type === GRAPH_PERCENT ? 'PERCENT' : 'YEAR',
        objectTypes
      }),
      method: 'get',
    })

    const {
      content,
      pageable,
    } = response.data
    const formattedData = content.map((row) => ({
      ...row,
      startDateExploitation: row.startDateExploitation ? row.startDateExploitation : null,
      dateEndExploitation: row.dateEndExploitation ? row.dateEndExploitation : null,
      currentDateExploitation: getFormattedCurrentDateExploitation(row.currentExploitation),
    }))
    yield put(setGlobalLoading(false))
    yield put(successLiveTimeReportTable({
      data: formattedData,
      totalElements: pageable.totalElements,
    }))
  } catch (error) {
    yield put(setGlobalLoading(false))
    yield put(errorLiveTimeReportTable(error))
  }
  return null
}

export default function* root() {
  yield takeLatest(GET_LIVE_TIME_REPORT_TABLE.REQUEST, getLiveTimeReportTableSaga)
  yield takeLatest(LIVE_TIME_REPORT_TABLE.SORT, getLiveTimeReportTableSaga)
  yield takeLatest(LIVE_TIME_REPORT_TABLE.PER_PAGE, getLiveTimeReportTableSaga)
  yield takeLatest(LIVE_TIME_REPORT_TABLE.PAGE, getLiveTimeReportTableSaga)
  // yield takeLatest(LIVE_TIME_REPORT_TABLE.SELECTED_FIELDS, getLiveTimeReportTableSaga)
  yield takeLatest(LIVE_TIME_REPORT_TABLE.REQUEST_QUERY, getLiveTimeReportTableSaga)
  yield takeLatest(SET_BAR_GRAPH_PERSENT_OPTIONS, getLiveTimeReportTableSaga)
  yield takeLatest(SET_BAR_GRAPH_YEAR_OPTIONS, getLiveTimeReportTableSaga)
  yield takeLatest(SET_GRAPH_TYPE, getLiveTimeReportTableSaga)
}
